import { stats } from "@/mocks/guatrend";

const principles = [
  { icon: "ri-user-heart-line", title: "真实网友优先", desc: "只收录真实用户反复分享、收藏与点赞的内容，让口碑回归口碑。" },
  { icon: "ri-shield-check-line", title: "拒绝注水刷分", desc: "所有评分与点评都会核对来源，异常与水分数据定期清理。" },
  { icon: "ri-refresh-line", title: "每周持续甄选", desc: "榜单每日更新，高分合集每周甄选，保持内容的鲜活与可信。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="relative w-full overflow-hidden bg-primary-950 py-16 md:py-24">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-700/30 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-accent-600/20 blur-3xl"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-50 ring-1 ring-background-50/20 whitespace-nowrap">
              <i className="ri-seedling-line text-primary-300"></i>
              关于吃瓜精选
            </span>
            <h2 className="font-display mt-5 text-2xl leading-snug text-background-50 md:text-4xl">
              我们只做一件事：<br />
              帮你把高分好瓜，挑得明明白白
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-background-50/80 md:text-base">
              吃瓜精选是一个以真实网友反馈与评分为核心的内容甄选站。我们持续收集被反复提及的热门主题，结合好评占比、收藏与转发热度，逐期整理成高分合集与口碑内容，替你过滤掉注水与噱头，只留下真正值得一看的优质好瓜。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-background-50/70">
              无论你是老瓜农还是新吃瓜人，都能从这里获得靠谱推荐。口碑之选，放心食用，是我们始终不变的承诺。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-1">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-3 rounded-xl bg-background-50/5 p-4 ring-1 ring-background-50/10">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-background-50">{p.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-background-50/70">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20scene%20of%20a%20curation%20desk%20with%20open%20magazines%2C%20paper%20notes%2C%20a%20hot%20cup%20of%20tea%2C%20watermelon%20and%20fresh%20greens%20in%20soft%20morning%20light%2C%20careful%20content%20selection%20and%20note%20taking%20atmosphere%2C%20cream%20and%20sage%20palette%2C%20editorial%20photography%2C%20high%20detail%2C%20calm%20and%20harmonious%20composition&width=900&height=700&seq=gua-about-01&orientation=portrait"
                alt="吃瓜精选口碑内容编辑甄选日常"
                className="h-full w-full object-cover object-center"
              />
            </div>

            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl bg-background-50/5 p-4 text-center ring-1 ring-background-50/10">
                  <p className="font-display text-2xl text-primary-300">{s.num}</p>
                  <p className="mt-1 text-xs text-background-50/70 whitespace-nowrap">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}